import { render } from "./tab-2.vue?vue&type=template&id=38dace3a&scoped=true"
import script from "./tab-2.vue?vue&type=script&lang=js"
export * from "./tab-2.vue?vue&type=script&lang=js"

import "./tab-2.vue?vue&type=style&index=0&id=38dace3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38dace3a"

export default script